/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Tooltip, Typography } from 'antd';

const { Paragraph } = Typography;

const Truncate = ({
  text = '',
  maxChar = 30
}) => {
  const [truncated, setTruncated] = useState(null);
  const [full, setFull] = useState(null);

  useEffect(() => {
    if (text && typeof text === 'string') {
      if (text.length > maxChar) {
        setTruncated(`${text.slice(0, maxChar - 1)}…`);
        setFull(text);
      } else {
        setTruncated(text);
      }
    }
  }, [text])

  return <span style={{ cursor: 'default' }}>
    {full ? <Tooltip title={full}>{truncated}</Tooltip> : (truncated ? truncated : null)}
  </span>;
}

export const EllipsisText = ({ children = null, ellipsis = {}, ...props }) => {
  const [truncated, setTruncated] = useState(false);

  return (
    <Tooltip title={truncated ? children : undefined}>
      <Paragraph
        {...props}
        ellipsis={{ ...ellipsis, onEllipsis: setTruncated }}
        style={{ ...(props.style || {}), marginBottom: 0}} 
      >
        <>{children}</>
      </Paragraph>
    </Tooltip>
  );
};

export default Truncate;
